import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import Image from "./Image";
import Container from "./Container";
import Wrapper from "./Wrapper";
import Title from "./Title";
import Subtitle from "./Subtitle";
var propTypes = {
  theme: PropTypes.shape({
    tableThumbnail: PropTypes.oneOf(['dark'])
  }),
  img: PropTypes.string,
  imgAlt: PropTypes.string,
  thumbnailTitle: PropTypes.node,
  subtitle: PropTypes.node,
  small: PropTypes.bool,
  truncate: PropTypes.bool
};
var defaultProps = {
  theme: {}
};
export default function TableThumbnail(_ref) {
  var img = _ref.img,
      imgAlt = _ref.imgAlt,
      thumbnailTitle = _ref.thumbnailTitle,
      subtitle = _ref.subtitle,
      small = _ref.small,
      theme = _ref.theme,
      truncate = _ref.truncate,
      props = _objectWithoutProperties(_ref, ["img", "imgAlt", "thumbnailTitle", "subtitle", "small", "theme", "truncate"]);

  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(Container, props, img && React.createElement(Image, {
    src: img,
    alt: imgAlt,
    small: small
  }), React.createElement(Wrapper, null, thumbnailTitle && React.createElement(Title, {
    truncate: truncate
  }, thumbnailTitle), subtitle && React.createElement(Subtitle, {
    truncate: truncate
  }, subtitle))));
}
TableThumbnail.darkTheme = {
  tableThumbnail: 'dark'
};
TableThumbnail.propTypes = propTypes;
TableThumbnail.defaultProps = defaultProps;